import { Component, OnInit, ChangeDetectionStrategy, Input, AfterViewInit, EventEmitter, Output, QueryList, ViewChildren } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { Guid } from 'guid-typescript';
import { WorkItemModel } from '../../models/work-item';
import { FileUploadModel } from '../../models/file-upload.model';
import { WorkDocumentFoundationService, WorkAttachmentTypeFoundationService } from 'e5core-angular-services';
import { E5coreUiGenerateDocumentBaseComponent } from './component/e5core-ui-generate-document-base';
import { WorkAttachmentAddEvent } from '../../events/work-attachment-add-event';
import { UiStyleService } from '../../services/ui-style.service';

@Component({
  selector: 'e5core-ui-generate-document',
  template: `
  <span *ngIf="workItem$" [ngSwitch]="style.current()">
  <e5core-ui-generate-document-box *ngSwitchCase='0' [showGenerateButton]='showGenerateButton' [readonly]='readonly' (selectDocumentTemplateEvent)='onSelectDocumentTemplate($event)' (selectAttachmentTypeEvent)='onSelectAttachmentType($event)' (generateDocumentEvent)='onGenerateDocument($event)'></e5core-ui-generate-document-box>
  <e5core-ui-generate-document-bootstrap *ngSwitchCase='1' [showGenerateButton]='showGenerateButton' [readonly]='readonly' (selectDocumentTemplateEvent)='onSelectDocumentTemplate($event)' (selectAttachmentTypeEvent)='onSelectAttachmentType($event)' (generateDocumentEvent)='onGenerateDocument($event)'></e5core-ui-generate-document-bootstrap>
  <e5core-ui-generate-document-material *ngSwitchCase='2' [showGenerateButton]='showGenerateButton' [readonly]='readonly' (selectDocumentTemplateEvent)='onSelectDocumentTemplate($event)' (selectAttachmentTypeEvent)='onSelectAttachmentType($event)' (generateDocumentEvent)='onGenerateDocument($event)'></e5core-ui-generate-document-material>
  </span>
  <div *ngIf="!(workItem$)" class="e5core-component-error">&lt;e5core-ui-generate-document&gt; [workItem$] must have a BehaviorSubject&lt;WorkItemModel&gt;</div>`,
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class E5coreUiGenerateDocumentComponent implements OnInit {

  @Input() workItem$: BehaviorSubject<WorkItemModel>;
  @Input() fileUpload$: BehaviorSubject<FileUploadModel>;
  @Input() showGenerateButton: boolean = true;
  @Input() readonly: boolean = false;
  @Output() generateDocumentEvent = new EventEmitter<WorkAttachmentAddEvent>();

  private selectedDocumentTemplateId: any = 0;
  private selectedAttachmentTypeId: any = 0;

  @ViewChildren(E5coreUiGenerateDocumentBaseComponent)
  public generateDocumentComponents: QueryList<E5coreUiGenerateDocumentBaseComponent>;

  constructor(
    public style:UiStyleService,
    private workAttachmentTypeFoundationService: WorkAttachmentTypeFoundationService,
    private workDocumentFoundationService: WorkDocumentFoundationService
  ) { }

  ngOnInit() {
    if (this.workItem$ == null) {
      console.error('e5core-ui-generate-document [workItem$] must have a BehaviorSubject<WorkItemModel>');
      return;
    }

    if (typeof this.workItem$ != 'undefined') {
      this.workItem$.subscribe(
        wim => {
          if (wim.workId != null && wim.workId != Guid.EMPTY) {
            this.populateDocumentTemplates(wim.workId);
            this.populateAttachmentTypes(wim.workId);
          }
        }
      )
    }
  }

  public populateAttachmentTypes(wid: string) {
    this.workAttachmentTypeFoundationService.get(wid).subscribe(
      s => {
        this.generateDocumentComponents.forEach(element => {
          element.attachmentTypes = s;
        });
      },
      error => {
        console.error(error);
      }
    )
  }

  public populateDocumentTemplates(wid: string) {
    this.workDocumentFoundationService.getDocumentTemplates(wid, null).subscribe(
      s => {
        this.generateDocumentComponents.forEach(element => {
          element.documentTemplates = s;
        });
      },
      error => {
        console.error(error);
      }
    )
  }

  public onGenerateDocument(event): void {
    this.generateDocument();
  }

  public generateDocument(): void {
    if (this.selectedDocumentTemplateId != 0) {
      var wid = this.workItem$.getValue().workId;

      this.workDocumentFoundationService.create(wid, this.selectedDocumentTemplateId, this.selectedAttachmentTypeId).subscribe(
        s => {
          if (typeof this.workItem$ != "undefined") {
            this.workItem$.next(this.workItem$.getValue());
          }
          if (typeof this.fileUpload$ != "undefined") {
            this.fileUpload$.next(this.fileUpload$.getValue());
          }
          this.generateDocumentEvent.emit({workId: wid, id: null, name: s.name, fullUrl: s.documentUrl});
        },
        error => {
          console.error(error);
          throw error;
        }
      )
    }
  }

  public onSelectDocumentTemplate(event): void {
    this.selectedDocumentTemplateId = event.value.id;
  }

  public onSelectAttachmentType(event): void {
    this.selectedAttachmentTypeId = event.value.id;
  }

}
